module.exports = __webpack_public_path__ + "static/img/rating-emoji-3.0b82f6e.png";